import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  initials,
  name,
  location,
  text
}: TestimonialProps) => <div className="bg-brand-card p-3 md:p-4 rounded-xl border border-white/5 flex flex-col h-full hover:border-brand-accent/30 transition-colors" data-id="element-265">
    <div className="flex items-center mb-2" data-id="element-266">
      <div className="w-9 h-9 bg-brand-accent text-brand-dark rounded-full flex items-center justify-center font-black text-sm mr-3 shrink-0" data-id="element-267">
        {initials}
      </div>
      <div data-id="element-268">
        <div className="flex text-brand-accent mb-0.5" data-id="element-269">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-270" />)}
        </div>
        <p className="font-bold text-white text-xs leading-tight" data-id="element-271">{name}</p>
        <p className="text-[10px] text-gray-400 font-medium" data-id="element-272">{location}</p>
      </div>
    </div>
    <p className="text-gray-300 text-xs italic flex-grow leading-snug font-medium" data-id="element-273">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection1() {
  const testimonials = [{
    initials: 'MG',
    name: 'Mariana G.',
    location: 'Entrenadora Funcional — Buenos Aires, Argentina',
    text: 'Organicé todo mi año de clases en una tarde. Nunca pensé que un material iba a ser tan completo.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Entrenadora Personal — Bogotá, Colombia',
    text: 'Mis clases de adultos por fin tienen progresión real. Ya no tengo que estar buscando ejercicios nuevos en Instagram.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Entrenador Funcional — Ciudad de México, México',
    text: 'Nunca más llegué a dar una clase sin plan. Resolví un mes completo de clases en 30 minutos.'
  }];
  return <section className="py-4 md:py-8 px-4 bg-brand-dark" data-id="element-274">
      <div className="max-w-4xl mx-auto" data-id="element-275">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-276">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-277" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSection2() {
  const testimonials = [{
    initials: 'MG',
    name: 'Mariana G.',
    location: 'Entrenadora Funcional | Buenos Aires, Argentina',
    text: 'Compré el Kit un domingo a la noche. El lunes tenía todo el mes de clases organizado. Nunca pensé que un material iba a ser tan completo. Los guiones de clase son exactamente lo que necesitaba: no tengo que pensar de cero para cada sesión.'
  }, {
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Entrenadora Personal | Montevideo, Uruguay',
    text: 'Empecé con el Kit Base y a los tres días compré el Completo. Doy clases a principiantes y a intermedios y no podía trabajar con la mitad del sistema. El Bono de Juegos y Dinámicas me cambió las clases grupales: mis alumnos ahora no faltan nunca porque se enganchan desde el primer minuto.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Entrenador Funcional | Ciudad de México, México',
    text: 'El Tomo de Programación me salvó el año. La planificación siempre fue mi peor pesadilla. Con el Kit resolví un mes completo de clases en 30 minutos con progresión, carga y formato incluidos. Mis alumnos me preguntaron si había hecho algún curso nuevo.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    location: 'Entrenador Funcional | Santiago, Chile',
    text: 'Lo que más valoro es que está organizado POR NIVEL. No tengo que adivinar qué ejercicio le corresponde a cada alumno. Todo ya está pensado, ordenado y listo. Es como tener un colega experto que ya hizo todo el trabajo por mí.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Entrenadora Personal | Bogotá, Colombia',
    text: 'Como entrenadora de grupos intermedios lo que más me cambió fueron los Tomos 4 y 5. Mis alumnos por fin se enganchan con la clase porque el contenido los desafía de verdad. Ya no tengo que estar buscando ejercicios nuevos en Instagram.'
  }, {
    initials: 'VT',
    name: 'Valeria T.',
    location: 'Entrenadora Funcional | Lima, Perú',
    text: 'No tengo equipamiento en el espacio donde entreno y pensé que el material no me iba a servir. Pero el Bono de Clases Express resolvió todo. Mis clases funcionan con el peso corporal y lo que hay en cualquier espacio. No necesité gastar nada más.'
  }];
  return <section className="py-6 md:py-10 px-4 bg-brand-dark" data-id="element-278">
      <div className="max-w-5xl mx-auto" data-id="element-279">
        <h2 className="text-xl md:text-2xl font-black text-center mb-6 text-white" data-id="element-280">
          ❤️ Lo que dicen los entrenadores que ya tienen su Kit
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-281">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-282" />)}
        </div>
      </div>
    </section>;
}